
<template lang="">
    <UserLayout ref="orderLayout"  pageTitle="Gestione ordini">
      <template #page-content="props"> 
              <!-- <v-card
                  class="form-card" 
                  outlined 
                  >  -->
                  <FrmManageOrders   ></FrmManageOrders>

              <!-- </v-card> -->
      </template>
  </UserLayout>  
</template>
<script>
import UserLayout from "../layout/UserLayout"; 
import FrmManageOrders from "../components/Management/FrmManageOrders";
import SessionHelper from "../utils/SessionHelper";
export default {
  mounted(){
    
    SessionHelper.checkRedirects(this.$route.params.companyAlias);
  },
  components: {
    FrmManageOrders,
    UserLayout,
  },
  methods:{
    CurrentUserChanged(user){
      this.$refs.userLayout.CurrentUserChanged(user);
    }
  }
};
</script>
<style lang="">
</style> 